import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../../query/types';

const roleKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'roles'] as const,
    id: <U extends QueryKeyParam>(itemId: U) =>
      createQueryKey({
        all: [...keys, 'roles', itemId] as const,
      }),
  });

export { roleKeys };
